import React from 'react';
import { 
  Drawer, 
  List, 
  ListItem, 
  ListItemIcon, 
  ListItemText, 
  Divider,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { styled } from '@mui/material/styles';
import TimelineIcon from '@mui/icons-material/Timeline';
import StarIcon from '@mui/icons-material/Star';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import ExploreIcon from '@mui/icons-material/Explore';

// ナビゲーションドロワーの幅
const drawerWidth = 240;

// スタイル付きのドロワーコンポーネント
const StyledDrawer = styled(Drawer)(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  '& .MuiDrawer-paper': {
    width: drawerWidth,
    boxSizing: 'border-box',
    backgroundColor: theme.palette.background.default,
    borderRight: `1px solid ${theme.palette.divider}`,
  },
}));

// 選択されたアイテムのスタイル
const SelectedListItem = styled(ListItem)(({ theme }) => ({
  backgroundColor: theme.palette.action.selected,
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}));

const Navigation = ({ currentView, onNavItemClick }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  // ナビゲーションアイテムの定義
  const navItems = [
    { id: 'timeline', text: '時系列ビュー', icon: <TimelineIcon /> },
    { id: 'favorites', text: 'お気に入り', icon: <StarIcon /> },
    { id: 'keywords', text: 'キーワード', icon: <BookmarkIcon /> },
    { id: 'discovery', text: '発見', icon: <ExploreIcon /> },
  ];

  // ナビゲーションアイテムのレンダリング
  const renderNavItems = () => {
    return navItems.map((item) => {
      const ListItemComponent = currentView === item.id ? SelectedListItem : ListItem;
      
      return (
        <ListItemComponent 
          button 
          key={item.id}
          onClick={() => onNavItemClick(item.id)}
        >
          <ListItemIcon>
            {item.icon}
          </ListItemIcon>
          <ListItemText primary={item.text} />
        </ListItemComponent>
      );
    });
  };

  // モバイル表示の場合は一時的なドロワー、それ以外は永続的なドロワー
  const variant = isMobile ? 'temporary' : 'permanent';

  return (
    <StyledDrawer
      variant={variant}
      anchor="left"
      open={!isMobile || false} // モバイルの場合、別途開閉状態を管理する必要あり
    >
      <List>
        {renderNavItems()}
      </List>
      <Divider />
    </StyledDrawer>
  );
};

export default Navigation;
